/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import firebase from 'firebase';

export const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseImpl = firebase.initializeApp(config);
export const firebaseDatabase = firebase.database();

export const getErrorMessage = (error) => {
  switch (error.code) {
    case 'auth/wrong-password':
      return 'Usuário ou senha inválidos!';
    case 'auth/invalid-email':
      return 'Formato de e-mail inválido!';
    case 'auth/email-already-in-use':
      return 'O e-mail informado já está em uso!';
    case 'auth/weak-password':
      return 'A senha deve conter ao menos 6 caracteres!';
    case 'auth/user-not-found':
      return 'Email não encontrado. O endereço pode estar errado ou o usuário pode ter sido excluído.';
    case 'auth/network-request-failed':
      return 'Internet indisponível. Verifique sua conexão e tente novamente.';
    default:
      return error.message;
  }
};
